module.exports = __webpack_public_path__ + "img/ltkshoecrush-3x.510507b.jpg";